import { useStandortContext } from '@/features/standortContext/StandortContext';
import { managerV1BaseUrl } from '@/utils';
import { ReactNode, useEffect } from 'react';

type Countries = 'DE' | 'AT' | 'CH';

const NavigateToV1 = ({ destinationURL }: { destinationURL: string }) => {
  useEffect(() => {
    window.location.replace(destinationURL);
  }, [destinationURL]);
  return <></>;
};

export function WithLocationGuard({
  children,
  countries,
  fallbackURL = managerV1BaseUrl,
}: {
  children: ReactNode;
  countries: Countries[];
  fallbackURL?: string;
}) {
  const { currentStandort } = useStandortContext();

  const lowerCaseCountries = countries.map((c) => c.toLowerCase());

  if (lowerCaseCountries.includes(currentStandort?.land.toLowerCase())) {
    return children;
  }

  return <NavigateToV1 destinationURL={fallbackURL} />;
}
